<template>
  <div class="product-view" id="tiktok">

    <AdTiktokGoals
      v-if="campaigns.data"
      :totalImpressions="campaigns.summary.totalImpressions"
      :totalClicks="campaigns.summary.totalClicks"
      :totalCtrPercentage="campaigns.summary.totalCtrPercentage"
      :totalReach="campaigns.summary.totalReach"
      :totalComments="campaigns.summary.totalComments"
      :totalLikes="campaigns.summary.totalLikes"
      :totalShares="campaigns.summary.totalShares"
      :totalVideoViews="campaigns.summary.totalVideoViews"
      :wording="wordings"
    ></AdTiktokGoals>

    <tiktok-campaings :campaigns="campaigns.data"> </tiktok-campaings>
  </div>
</template>

<script>
//services 🏗️
import { ServiceFactory } from "../../services";

//packages 📦
import { mapGetters } from "vuex";

//components
import TiktokCampaings from "@/components/Widgets/TiktokCampaings.vue";
import AdTiktokGoals from "../../components/Widgets/AdTiktokGoals.vue";

export default {
  name: "tiktok",
  components: {
    TiktokCampaings,
    AdTiktokGoals
  },
  data: () => ({
    wordings: {
      Impressions:"Cantidad de veces que su publicidad fue expuesta a su público objetivo",
      Clicks: "Número de veces que los usuarios hicieron clic en el anuncio",
      CTR: "Porcentaje de clics en relación con las impresiones",
      Reach: "Número de usuarios únicos que vieron el anuncio",
      Comments: "Número de comentarios generados en el anuncio",
      Likes: "Cantidad de “me gusta” recibidos en el anuncio",
      Shares: "Número de veces que el anuncio fue compartido",
      VideoViews: "Número de veces que los usuarios vieron el video hasta el final"
    },
    product: [],
    campaigns: [],
    date: {
      startDate: "",
      endDate: ""
    },
    TiktokService: () => {}
  }),
  watch: {
    date1: async function() {
      this.date.startDate = this.$store.state.subscriber.date2;
      this.date.endDate = this.$store.state.subscriber.date1;
      this.fetchTiktokCampaigns();
    },
    date2: async function() {
      this.date.startDate = this.$store.state.subscriber.date2;
      this.date.endDate = this.$store.state.subscriber.date1;
      this.fetchTiktokCampaigns();
    }
  },
  async created() {
    this.TiktokService = await ServiceFactory.createInstance({
      type: "TiktokService",
      data: this
    });

    this.date.startDate = this.$store.state.subscriber.date2;
    this.date.endDate = this.$store.state.subscriber.date1;

    this.fetchTiktokCampaigns();
  },
  methods: {
    async fetchTiktokCampaigns() {
      const { customerId } = this.$route.query;
      const advertiser_id = customerId;
      
      this.campaigns = await this.TiktokService.GetTiktokCampaigns({
        start_date: this.date.startDate,
        end_date: this.date.endDate,
        advertiser_id
      });
    }
  },
  computed: {
    ...mapGetters(["date1", "date2"])
  }
};
</script>

<style></style>
